module.exports = __webpack_public_path__ + "assets/img/nature-c-bg2.819e975c.png";